import { render, staticRenderFns } from "./NormativaPermissoes.vue?vue&type=template&id=3ec4fe58&scoped=true"
import script from "./NormativaPermissoes.vue?vue&type=script&lang=js"
export * from "./NormativaPermissoes.vue?vue&type=script&lang=js"
import style0 from "./NormativaPermissoes.vue?vue&type=style&index=0&id=3ec4fe58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4fe58",
  null
  
)

export default component.exports